export const menus: MenuType[] = [
  {
    title: '公司管理',
    path: '/compony-set/index',
    children: [],
    code: 'sys_manager',
  },
  {
    title: '用户管理',
    path: '/users-set/list',
    children: [],
    code: 'user_manager',
  },
  {
    title: '审查规则配置',
    path: '/rule-config',
    code: 'rule_manager',
    children: [
      {
        title: '规则管理',
        path: '/rule-config/rules',
        children: [],
      },
      {
        title: '对象管理',
        path: '/rule-config/objects',
        children: [],
      },
      {
        title: '属性管理',
        path: '/rule-config/props',
        children: [],
      },
    ],
  },
  {
    title: '公共素材管理',
    path: '/source-material/list',
    code: 'resource_lib_manager',
    children: [],
  },
  {
    title: '转换管理',
    commonPath: '/oss-status',
    path: '/oss-status/list',
    children: [],
    code: 'transfer_manager',
  },
  {
    title: '弹性伸缩',
    path: '/flex-group/list',
    code: 'ecs_manager',
    children: [],
  },
  // {
  //   title: '企业管理',
  //   path: '/oss-enterprise',
  //   children: [
  //     {
  //       title: '激活码管理',
  //       path: '/oss-enterprise/list',
  //       children: [],
  //     },
  //   ],
  // },
  {
    title: 'MTBF统计',
    path: '/oss-mtbf/list',
    children: [],
    // code: 'transfer_manager',
  },
  {
    title: '小程序绑定',
    path: '/app-binding/list',
    children: [],
  },
  {
    title: '应用管理',
    path: '/app-manage/list',
    children: [],
  },
  {
    title: '签约和支付设置',
    path: '/sign-payment/list',
    children: [],
  },
  {
    title: 'SLA',
    path: '/sla/list',
    children: [],
  },
  {
    title: '渲染管理',
    commonPath: '/render-management',
    path: '/render-management',
    children: [],
  },
];
